module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-table"
  }, [_c('table', [_c('thead', [_c('th', {
    staticClass: "col-xs-7"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('th', {
    staticClass: "col-xs-3",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Show")])]), _vm._v(" "), _c('tbody', _vm._l((_vm.data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.show) + "%")])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39a45542","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/programmingDashboard/AudienceProfileTable.vue
// module id = 3226
// module chunks = 3